export const getPackCountText = (cardCount: number, categoryIds?: number[]) =>
  categoryIds ? `${categoryIds?.length} pack` : `${cardCount} pack`
